module.exports = __webpack_public_path__ + "img/wallet.fd97d01c.svg";